import React from 'react';
import { useSelector } from 'react-redux';

import useChannelDetails from 'hooks/useChannelDetails';
import { selectSelectedContent } from 'redux/content/content.slice';

import { MobilePreview } from './MobilePreview';

const samplePlanHtml = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Sample Plan</title>
  <style>
    body {
      font-family: 'Arial', sans-serif;
      background-color: #f0f0f0;
      text-align: center;
      padding: 20px;
    }
    h1 {
      color: #333;
    }
    p {
      color: #555;
      margin-bottom: 20px;
    }
    .highlight {
      color: #e44d26;
      font-weight: bold;
    }
    .feature-list {
      text-align: left;
      margin-left: 20px;
    }
    .feature-list li {
      margin-bottom: 10px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
    }
    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: left;
    }
    form {
      margin-top: 20px;
    }
    .styled-div {
      background-color: #fff;
      border: 1px solid #ddd;
      padding: 10px;
      margin-top: 20px;
    }
  </style>
</head>
<body>
  <h1>Welcome to the Sample Plan</h1>
  <p>This is a demonstration of a sample HTML plan. You can customize the content as needed.</p>
  <p>Here are some key features:</p>
  <ul class="feature-list">
    <li><span class="highlight">Customizable</span>: Easily modify the content to suit your needs.</li>
    <li><span class="highlight">Responsive</span>: The plan adapts to different screen sizes.</li>
    <li><span class="highlight">Styled</span>: Basic styling for better visual presentation.</li>
    <li><span class="highlight">Interactive</span>: Incorporate interactive elements as required.</li>
    <li><span class="highlight">Images</span>: Include images to make your plan visually appealing.</li>
  </ul>
  <p>Feel free to update this HTML code to showcase your specific plan details!</p>
  <img src="https://via.placeholder.com/300" alt="Sample Image" />

  <table>
    <thead>
      <tr>
        <th>Name</th>
        <th>Price</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Product 1</td>
        <td>$19.99</td>
      </tr>
      <tr>
        <td>Product 2</td>
        <td>$29.99</td>
      </tr>
    </tbody>
  </table>

  <form>
    <label for="username">Username:</label>
    <input type="text" id="username" name="username">
    <br>
    <label for="password">Password:</label>
    <input type="password" id="password" name="password">
    <br>
    <button type="submit">Submit</button>
  </form>

  <div class="styled-div">
    <h2>Styled Div</h2>
    <p>This is a styled div with a border and padding.</p>
  </div>
</body>
</html>
`;

const ContentPreview = () => {
  const { channel } = useChannelDetails();
  const selectedContent = useSelector(selectSelectedContent);
  if (
    channel === 'email' &&
    selectedContent.templateType?.toLowerCase() === 'basic'.toLowerCase()
  ) {
    return (
      <div className="h-[40rem] w-full overflow-auto whitespace-pre-line flex justify-start items-start">
        {selectedContent.message}
      </div>
    );
  }
  if (channel === 'email')
    return (
      <iframe
        title="HTML Preview"
        style={{
          width: 'calc(100% - 62px)',
          height: '100%',
          minHeight: '45rem',
          backgroundColor: '#F2F4F7',
        }}
        srcDoc={selectedContent.message}
        sandbox="allow-scripts allow-same-origin allow-popups"
        referrerPolicy="no-referrer"
      />
    );

  return <MobilePreview />;
};

export default ContentPreview;
